import React, { useState, useEffect } from 'react';

const Clock = () => {
  // Состояние для хранения текущего момента времени
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Запускаем интервал, обновляющий время каждую секунду
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Очистка интервала при размонтировании компонента
    return () => clearInterval(intervalId);
  }, []); // Пустой массив зависимостей – эффект выполняется только один раз

  // Форматируем дату и время по желанию
  const formattedDate = currentTime.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const formattedTime = currentTime.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <div>
      <div>{formattedDate} | {formattedTime}</div>
    </div>
  );
};

export default Clock;